export const mapUserDto = (dto)=> ({
    id: dto.id,
    username: dto.username,
    name: dto.name,
    passwordClear: dto.passwordClear,
    projects: dto.projects,
});